module.exports = __webpack_public_path__ + "assets/img/0739c5b088fa4be7d271e8278ced03c1.97136682.png";